import { Btn, H3, H4, Image, LI, P, UL } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { Grid } from "react-feather";
import {FREE,  PlanSpace, PricingPlan, Selected, TrialVersion } from "../../../Constant";

const PricingPlans = () => {
  return (
    <UL className="simple-list">
      <LI>
        <Btn outline color="primary" className="w-100 progress-text"><Grid/>{PricingPlan}</Btn>
      </LI>
      <LI>
        <div className="pricing-plan">
          <H4 className="f-w-700">{TrialVersion} </H4>
          <H3>{FREE}</H3>
          <P>{PlanSpace}</P>
          <Btn size="xs" outline color="primary">{Selected}</Btn>
          <Image className="bg-img" src={dynamicImage("dashboard/folder.png")} alt=""/>
        </div>
      </LI>
    </UL>
  );
};

export default PricingPlans;
